"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.dashboardStyles = exports.inputStyles = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

var _Font = require("../../Constant/Font");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  ", "\n  margin-top: 8px;\n  font-size: 1.6rem;\n  border: 1px solid ", ";\n\n  &:hover:not([disabled]) {\n    border-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// copied from /src/Form/Input/Input.js, frontlib-gui.
var inputStyles = "\n  background-color: initial;\n  border: 0;\n  width: 100%;\n  outline: none;\n  font-size: 1.6rem;\n  letter-spacing: 0.015em;\n  border-bottom: 1px solid ".concat(_Constant.Color.BLACK_SOUL, ";\n  color: ").concat(_Constant.Color.BLACK_SOUL, ";\n  margin-top: 10px;\n  border-radius: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-bottom: 6px;\n  line-height: normal;\n  appearance: none;\n  &::placeholder {\n    color: ").concat(_Constant.Color.GREY_4, ";\n  }\n  &:disabled {\n    padding: 5px;\n    cursor: not-allowed;\n    color: ").concat(_Constant.Color.GREY_4, " !important;\n    opacity: 1;\n  }\n  &:invalid {\n    box-shadow: none;\n  }\n"); // custom dashboard-style css

exports.inputStyles = inputStyles;
var dashboardStyles = "\n  height: 6.2rem;\n  padding: 20px;\n  margin-top: 0;\n  border-bottom: 0;\n  font-family: ".concat(_Font.PRIMARY_FONT, ";\n  font-weight: 600;\n  font-size: 1.5rem;\n\n  &:disabled {\n    background-color: ").concat(_Constant.Color.GREY_2, ";\n    padding: 20px;\n    cursor: not-allowed;\n  }\n");
exports.dashboardStyles = dashboardStyles;

var Input = _styledComponents.default.input.attrs(function (_ref) {
  var errorText = _ref.errorText,
      className = _ref.className,
      fsMask = _ref.fsMask;
  return {
    className: "".concat(fsMask ? 'fs-mask ' : '').concat(className || ''),
    'data-error': errorText && errorText.length > 0
  };
})(_templateObject(), inputStyles, dashboardStyles, function (props) {
  return props['data-error'] ? _Constant.Color.LIPSTICK_RED : _Constant.Color.GREY_4;
}, _Constant.Color.FOCUS_B);

var _default = Input;
exports.default = _default;